import {
    AfterContentInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { bindFunctionsToThis } from '../../extensions';

@Component({
    selector: 'ig-water-fall-container',
    templateUrl: './water.fall.container.component.html',
    styleUrls: ['./water.fall.container.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class WaterFallContainerComponent implements AfterContentInit {
    private _reLayoutTimer: any;
    private _reLayoutDelay = 200;
    private _currentItemCount: number;
    private _columnOffsets: number[];
    private _2timesWidthItemIndexes = [];
    public isLoadingItems: boolean;
    public isInitialLayoutCompleted = false;

    @Input() public horizonPadding = 5;
    @Input() public itemWidth = 200;
    @Input() public itemMaxWidth = 250;
    @Input() public maxColumnCount = 6;
    @Input() public gap = 16;
    @Input() public isAllItemsLoaded: boolean;
    @Input() public isHideSpinner: boolean;
    @Input() public isRandom2TimesWidthCard = false;
    @Input() public modernBlockStyle: boolean = false;
    @Output() public onLoadMore = new EventEmitter<WaterFallLoadMoreEvent>();
    @ViewChild('container') public container: ElementRef;

    public get isScrolledToEnd(): boolean {
        if (!this.container) {
            return false;
        }

        let { scrollTop, scrollHeight, clientHeight } = this.container.nativeElement;

        return scrollHeight - scrollTop === clientHeight;
    }

    constructor(private render: Renderer2) {
        bindFunctionsToThis(this);
    }

    public ngAfterContentInit() {
        this.render.listen(this.container.nativeElement, 'scroll', this.onScroll);
        setTimeout(this.reLayout, 0);
    }
6
    public startLoading() {
        this.isLoadingItems = true;
    }

    public onScroll() {
        if (this.isLoadingItems || this.isAllItemsLoaded) {
            return;
        }

        let { scrollTop, scrollHeight, clientHeight } = this.container.nativeElement;
        if (scrollHeight - scrollTop < clientHeight * 4) {
            this.onLoadMore.emit({ loadMore: this.loadItems });
            this.isLoadingItems = true;
        }
    }

    @HostListener('window:resize')
    public reLayout(isLoadMoreItems = false) {

        if (!!this._reLayoutTimer) {
            clearTimeout(this._reLayoutTimer);
        }

        let container = this.container.nativeElement;
        let containerWidth: number;

        this._reLayoutTimer = setTimeout(() => {
            let layout = () => {
                containerWidth = container.clientWidth;
                let children = Array.prototype.slice.call(container.children);
                let columnCount = Math.floor(containerWidth / (this.itemWidth + this.gap));
                columnCount = Math.min(columnCount, this.maxColumnCount) || 1;
                let remainWidth = (containerWidth) - columnCount * (this.itemWidth + this.gap);
                let extractWidthForEachItem = remainWidth / columnCount;
                let _2TimesWidthItemWidth = `${(this.itemWidth + extractWidthForEachItem) * 2 + this.gap}px`;
                let layoutPendingItems = children;

                if (isLoadMoreItems) {
                    layoutPendingItems = children.slice(this._currentItemCount);
                } else {
                    this._columnOffsets = new Array(columnCount);
                    this._columnOffsets.fill(0, 0);
                    //this._2timesWidthItemIndexes = [];
                }

                //if (columnCount && layoutPendingItems.length && (this._currentItemCount !== children.length)) {
                if (this.isRandom2TimesWidthCard) {
                    columnCount--;
                    layoutPendingItems.filter(x => x.nodeName.toLowerCase() === 'div').forEach(x => x.remove());
                    layoutPendingItems = layoutPendingItems.filter(x => x.nodeName.toLowerCase() !== 'div');
                    let rowCount = Math.ceil(layoutPendingItems.length / columnCount);

                    for (let i = 0; i < rowCount - 1; i++) {
                        let arr = [];
                        for (let j = i * columnCount; j <= columnCount * (i + 1) - 1; j++) {
                            arr.push(j);
                        }
                        let random = arr.getRandom();
                        if ((i + 1) > this._2timesWidthItemIndexes.length) {
                            this._2timesWidthItemIndexes.push(random);
                            layoutPendingItems[random].style.width = _2TimesWidthItemWidth;
                            layoutPendingItems[random].style.zIndex = 2;
                        } else {
                            layoutPendingItems[this._2timesWidthItemIndexes[i]].style.width = _2TimesWidthItemWidth;
                            layoutPendingItems[this._2timesWidthItemIndexes[i]].style.zIndex = 2;
                        }
                    }
                    this._2timesWidthItemIndexes.forEach((random, index) => {
                        if (random + (1 + index) < layoutPendingItems.length) {
                            const div = document.createElement('div');
                            div.style.height = layoutPendingItems[random].clientHeight + 'px';
                            container.insertBefore(div, layoutPendingItems[random + (1 + index)]);
                            layoutPendingItems.splice(random + (1 + index), 0, div);
                        }
                    });
                }
                //}

                let itemHeights = layoutPendingItems.map(item => item.clientHeight);
                // Hide container to increase re-layout performance
                container.style.display = 'none';
                children.forEach(item => item.style.transition = '');
                this.loadNewStyle(extractWidthForEachItem);

                layoutPendingItems.forEach((item, index) => {
                    let { offsetTop, columnIndex } = this.getShortestColumnOffset();

                    let left = this.horizonPadding +
                        (this.itemWidth + extractWidthForEachItem) * columnIndex
                        + this.gap * columnIndex;

                    if (isLoadMoreItems) {
                        item.style.transform = `translate(${left}px, ${offsetTop}px) scale(0)`;
                        setTimeout(() => {
                            item.style.transition = 'transform .2s linear';
                            item.style.transform = `translate(${left}px, ${offsetTop}px) scale(1)`;
                        }, 0);
                    } else {
                        item.style.transform = `translate(${left}px, ${offsetTop}px)`;
                    }

                    this._columnOffsets[columnIndex] += itemHeights[index] + this.gap;
                });

                this._currentItemCount = children.length;

                container.style.display = '';
            };

            if (!this.modernBlockStyle) {
                layout();
            }

            setTimeout(() => {
                // After first layout, check if the vertical scroll bar shown, then layout again
                if (containerWidth && (containerWidth >= container.clientWidth)) {
                    layout();
                }
                this.isInitialLayoutCompleted = true;
                this.isLoadingItems = false;
            }, this._reLayoutDelay);
        }, this._reLayoutDelay);
    }

    public loadItems() {
        setTimeout(() => {
            this.reLayout(true);
        }, 0);
    }

    private getShortestColumnOffset(): { offsetTop: number, columnIndex: number } {
        let offsetTop = this._columnOffsets[0];
        let columnIndex = 0;

        for (let i = 1; i < this._columnOffsets.length; i++) {
            if (this._columnOffsets[i] < offsetTop) {
                offsetTop = this._columnOffsets[i];
                columnIndex = i;
            }
        }

        return { offsetTop, columnIndex };
    }

    private loadNewStyle(extractWidthForEachItem: number) {
        let previousStyle = document.querySelector('#water-fall-container');
        if (!!previousStyle) {
            try {
                previousStyle.remove();
            } catch (error) {
                previousStyle.parentNode.removeChild(previousStyle);
            }
        }

        let style = document.createElement('style');
        style.id = 'water-fall-container';
        style.type = 'text/css';
        style.innerHTML = `
            .water-fall-container > * {
                width: ${this.itemWidth + extractWidthForEachItem}px;
            }`;
        document.getElementsByTagName('head')[0].appendChild(style);
    }
}

export class WaterFallLoadMoreEvent {
    public loadMore: () => void;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/water.fall.container/water.fall.container.component.ts